import { render, staticRenderFns } from "./CardioChirurgiaList.vue?vue&type=template&id=6cc4fe90"
import script from "./CardioChirurgiaList.vue?vue&type=script&lang=js"
export * from "./CardioChirurgiaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports